import React, { useEffect, useRef } from 'react';
export function HeroSection() {
  const heroRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    const items = el.querySelectorAll('.hero-reveal');
    items.forEach((item, i) => {
      setTimeout(() => {
        item.classList.add('revealed');
      }, 150 + i * 180);
    });
  }, []);
  return <section ref={heroRef} className="relative w-full overflow-hidden" style={{
    backgroundColor: '#1a2744'
  }} aria-label="Hero section" data-id="element-127">
      {/* Subtle star decorations */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true" data-id="element-128">
        <span className="absolute top-8 left-12 text-yellow-200 opacity-20 text-xs" data-id="element-129">
          ✦
        </span>
        <span className="absolute top-16 left-1/4 text-yellow-200 opacity-10 text-[8px]" data-id="element-130">
          ✦
        </span>
        <span className="absolute top-24 right-16 text-yellow-200 opacity-25 text-sm" data-id="element-131">
          ✦
        </span>
        <span className="absolute top-12 right-1/3 text-yellow-200 opacity-15 text-[6px]" data-id="element-132">
          ✦
        </span>
        <span className="absolute bottom-20 left-8 text-yellow-200 opacity-15 text-[8px]" data-id="element-133">
          ✦
        </span>
        <span className="absolute bottom-32 right-12 text-yellow-200 opacity-20 text-xs" data-id="element-134">
          ✦
        </span>
        <span className="absolute top-1/3 left-6 text-yellow-200 opacity-10 text-[6px]" data-id="element-135">
          ✦
        </span>
        {/* Moon */}
        <span className="absolute top-6 right-8 text-4xl opacity-20" data-id="element-136">🌙</span>
      </div>

      <div className="relative max-w-6xl mx-auto px-6 py-16 md:py-24 lg:py-28" data-id="element-137">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-138">
          {/* Left: Text */}
          <div className="flex flex-col gap-6" data-id="element-139">
            {/* Eyebrow */}
            <div className="hero-reveal scroll-reveal" data-id="element-140">
              <span className="inline-block text-xs font-semibold tracking-widest uppercase px-3 py-1.5 rounded-full border" style={{
              color: '#c9a96e',
              borderColor: 'rgba(201,169,110,0.4)',
              backgroundColor: 'rgba(201,169,110,0.08)'
            }} data-id="element-141">
                For Parents of Toddlers 18mo–4yr
              </span>
            </div>

            {/* H1 */}
            <div className="hero-reveal scroll-reveal" data-id="element-142">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-white" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-143">
                The 3-Night{' '}
                <span className="italic" style={{
                color: '#c9a96e'
              }} data-id="element-144">
                  "No-Cry"
                </span>
                <br data-id="element-145" />
                Sleep Reset
              </h1>
            </div>

            {/* H2 / Subhead */}
            <div className="hero-reveal scroll-reveal" data-id="element-146">
              <p className="text-lg md:text-xl leading-relaxed" style={{
              color: '#d4cfc8',
              fontFamily: "'Inter', sans-serif",
              fontWeight: 400
            }} data-id="element-147">
                The Step-By-Step Circadian Anchoring Protocol to End Night
                Wakings and Bedtime Battles{' '}
                <em data-id="element-148">Without Leaving Your Child to Cry Alone.</em>
              </p>
            </div>

            {/* Divider */}
            <div className="hero-reveal scroll-reveal" data-id="element-149">
              <div className="gold-divider" style={{
              marginLeft: 0
            }} data-id="element-150" />
            </div>

            {/* CTA Button */}
            <div className="hero-reveal scroll-reveal flex flex-col gap-3" data-id="element-151">
              {/* Price display above button */}
              <div className="flex items-center gap-3 flex-wrap" data-id="element-152">
                <span className="text-base line-through" style={{
                color: 'rgba(212,207,200,0.5)',
                fontFamily: "'Inter', sans-serif"
              }} aria-label="Original price $19.99" data-id="element-153">
                  $19.99
                </span>
                <span className="text-2xl font-bold" style={{
                color: '#c9a96e',
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-154">
                  $6.36
                </span>
                <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold tracking-wide" style={{
                backgroundColor: 'rgba(201,169,110,0.2)',
                color: '#c9a96e',
                border: '1px solid rgba(201,169,110,0.5)',
                fontFamily: "'Inter', sans-serif"
              }} data-id="element-155">
                  68% OFF
                </span>
              </div>
              <button className="animate-pulse-gold inline-flex flex-col items-center justify-center px-8 py-4 rounded-xl font-semibold text-lg transition-transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-4 focus:ring-yellow-400 focus:ring-offset-2 focus:ring-offset-navy" style={{
              backgroundColor: '#c9a96e',
              color: '#1a2744',
              fontFamily: "'Inter', sans-serif",
              fontWeight: 600
            }} aria-label="Get the 3-Night No-Cry Sleep Reset for $6.36" onClick={() => {
              document.getElementById('final-cta')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-156">
                Start the 3-Night Sleep Reset Today
                <span className="text-sm font-normal mt-0.5 opacity-80" data-id="element-157">
                  Instant PDF Download • Start Tonight
                </span>
              </button>

              {/* Trust line */}
              <p className="text-sm text-center" style={{
              color: 'rgba(212,207,200,0.7)',
              fontFamily: "'Inter', sans-serif"
            }} data-id="element-158">
                Based on pediatric sleep science &nbsp;•&nbsp; No cry-it-out
              </p>
            </div>
          </div>

          {/* Right: Product Image */}
          <div className="hero-reveal scroll-reveal flex justify-center lg:justify-end" data-id="element-159">
            <div className="relative" data-id="element-160">
              {/* Glow behind image */}
              <div className="absolute inset-0 rounded-2xl blur-3xl opacity-20" style={{
              backgroundColor: '#c9a96e',
              transform: 'scale(0.9) translateY(10px)'
            }} aria-hidden="true" data-id="element-161" />
              <img src="https://cdn.magicpatterns.com/uploads/5i5NmggQDF3dY4mgEaVzH9/heylloyd-image-1772330868905.png" alt="Child sleeping peacefully with The 3-Night No-Cry Sleep Reset guide on tablet" className="relative rounded-2xl shadow-2xl w-full max-w-md lg:max-w-full object-cover" style={{
              border: '1px solid rgba(201,169,110,0.2)'
            }} data-id="element-162" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}